$(document).ready(function() {

  $('.modal-slider-section .portfolio-slider .item').on('click', function() {
    var clicked = $(this);
    $('.modal-slider-overlay').addClass('show');
    $('.modal-slider .slick-slide').removeClass('slick-active slick-current forward');
	$('.modal-slider .slick-slide').eq(clicked.index()).addClass('slick-active slick-current forward');
    console.log(clicked.index());
  });
  
  
  $('.modal-slider-section .modal-slider-overlay .slider-close').on('click', function() {
    $('.modal-slider-overlay').removeClass('show');
  });


});